export class QuoteCoverageDetails {
  liabilityAmount = 0;
  deductible = 0;
  personalPropertyAmount = 0;
  isMasonryConstruction = "";
  replacementCost = false;
  waterBackup = false;
  earthquake = false;
  iuiTypes = "N";
  iuiNumberOfBenefits = "0";
  iuiBenefitAmount = "0";
  petDamage = false;
  identityFraud = false;
  dwelingCreditSurcharge = ""; //A-D-S-T
  internetCredit = "";
  lossFreeCredit = "";
  mustHaveInsurance = "";
  hurricaneDeductible = 0;
}
